import { memo } from 'react';

import { createDataAttributes } from '@/app/utils/createDataAttributes';

export const TitleH2 = memo(({ title }: { title: string }) => (
  <h2
    className="font-display text-h2 where-span:text-inline-wrap"
    dangerouslySetInnerHTML={{ __html: title }}
    {...createDataAttributes({
      test: 'heading-title',
    })}
  />
));

TitleH2.displayName = 'TitleH2';
